export default [
  {
    "x": 229.324802,
    "y": 82.4029728,
    "angle": 1.5707963267948966,
    "lengthA": 12.412000000000006,
    "lengthB": 12.411000000000001
  },
  {
    "x": 204.987649,
    "y": 53.3468089,
    "angle": 0,
    "lengthA": 12.412000000000006,
    "lengthB": 12.411000000000001
  },
  {
    "x": 182,
    "y": 79.3482834,
    "angle": -1.5707963267948966,
    "lengthA": 12.411000000000001,
    "lengthB": 12.412000000000006
  },
  {
    "x": 203.123495,
    "y": 100.3872,
    "angle": 3.141592653589793,
    "lengthA": 12.411000000000001,
    "lengthB": 12.411000000000001
  }
]